import React, { useEffect, useState } from 'react';
import { useContainerQuery } from 'react-container-query';
import cx from 'classnames';
import { query } from 'Styles/breakpoints';
import ContainerQueryProvider, { ContainerQueryContext } from '../../util/ContainerQuery.context';
import * as Styled from './ContainerQuery.styled';
/**
 * Wraps a component to do a container query on
 *
 * Context Provider enables consumers in the child component to respond to changes in container size
 */
var ContainerQuery = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b;
    var _c = useContainerQuery(query, {}), params = _c[0], containerRef = _c[1];
    var _d = useState(false), widthIsCalculated = _d[0], setWidthIsCalculated = _d[1];
    useEffect(function () {
        setWidthIsCalculated(Object.keys(params).length > 0);
    }, [params]);
    return (React.createElement(ContainerQueryProvider, { className: cx(params) },
        React.createElement(ContainerQueryContext.Consumer, null, function (_a) {
            var containerQueryClassName = _a.containerQueryClassName;
            return (React.createElement(Styled.Container, { className: "".concat(className, " ").concat(containerQueryClassName), ref: containerRef, "$widthIsCalculated": widthIsCalculated }, children));
        })));
};
export default ContainerQuery;
